import { HTMLDataTrackerProps } from '@/app/types';
import { returnRefAndGenerateDataTracker } from '@/components/atoms/button/utils';
import { WithRef } from '@/components/types';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren<HTMLDataTrackerProps> &
  Partial<
    WithRef<HTMLButtonElement, React.ButtonHTMLAttributes<HTMLButtonElement>>
  >;

// Unstyled button wrapper exclusively for handling click tracking without any additional styles
const TrackerClickWrapper = (props: Props) => {
  return (
    <button
      {...props}
      ref={(_ref) => {
        returnRefAndGenerateDataTracker(_ref, props?.ref);
      }}
    />
  );
};

export default TrackerClickWrapper;
